import { THEME } from '../../../constants/themes';

// TODO: remove hardcoded domains and fetch them from a config service, before release!
const agentDomain = 'getbeem-dev.de';
const gcDomain = 'gcbeem-dev.de';

export const extractThemeFromQueryParam = () => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.hash.substring(url.hash.indexOf('?') + 1));

  return params.get('theme');
};

export const extractThemeFromWebUrl = (appThemes) => {
  const hostName = window.location.hostname.toLowerCase();

  let themeIdentifier = null;
  for (const theme of Object.values(appThemes)) {
    const { url } = theme;
    const urlName = url.includes('de') ? url.replace('.de', '') : url;
    const urlRegex = new RegExp(`(\\w*.)?${urlName}(-(dev|test))?.de`);
    if (urlRegex.test(hostName)) {
      themeIdentifier = theme.identifier;
      break;
    }
  }

  return themeIdentifier;
};

export const extractThemeFromMobilePackage = (packageId, appThemes) => {
  let themeIdentifier = null;
  for (const theme of Object.values(appThemes)) {
    if (theme.packageId === packageId) {
      themeIdentifier = theme.identifier;
      break;
    }
  }

  if (!packageId && !themeIdentifier) {
    // we extract the theme from the url
    themeIdentifier = extractThemeFromWebUrl(appThemes);
  }

  return themeIdentifier;
};

export const calculateApiBaseUrlForEnv = (apiBaseUrl, themeIdentifier) => {
  const env = import.meta.env.VITE_BUILD_ENVIRONMENT;
  const envApiBaseUrl = import.meta.env.VITE_API_BASE_URL;

  if (envApiBaseUrl) {
    return envApiBaseUrl;
  }

  if (env === 'production') {
    return apiBaseUrl;
  }

  // split by .de and attach the env then back the domain
  const [baseDomain] = apiBaseUrl.split('.de');
  return `${baseDomain}-${env}.de`;
};
